import { apiNetworkRequest, AppAsyncAction } from './helpers';

export const removeFavorite = (channelId: string): AppAsyncAction => async (dispatch) => {
  await dispatch(apiNetworkRequest('myList.removeFavourite', { assetId: channelId }));
};

export const addFavorite = (channelId: string): AppAsyncAction => async (dispatch) => {
  await dispatch(apiNetworkRequest('myList.addFavourite', { assetId: channelId }));
};
